export { default } from './Radio'
export type { ComponentProps as RadioProps } from './Radio'
